"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hubApiConfig = void 0;
class HubApiConfig {
  constructor() {
    this._axiosInstance = null;
  }
  init(config) {
    this._axiosInstance = config.axiosInstance;
  }
  getInstance() {
    if (!this._axiosInstance) {
      throw new Error('HubApiConfig | Axios instance must be defined');
    }
    return this._axiosInstance;
  }
}
exports.hubApiConfig = new HubApiConfig();